import React, { useState } from "react";
import styles from "./input.module.css";
import { ReactComponent as InputSvg } from "../../assets/img/home/input.svg";
import { ReactComponent as InputBorder } from "../../assets/img/home/inputBorder.svg";

import clsx from "clsx";

const Input = ({ type = "text", name = null }) => {
  const [isFocus, setIsFocus] = useState(false);
  return (
    <div
      className={clsx(styles.inputBlock, {
        [styles.inputBlockActive]: isFocus,
      })}
    >
      {isFocus && <div className={styles.inputTopLine} />}
      <input
        onFocus={() => setIsFocus(true)}
        onBlur={() => setIsFocus(false)}
        type={type}
        name={name}
        placeholder="Enter Your Email"
        className={styles.input}
      />
      <InputSvg className={styles.inputSvg} />
      {isFocus && <InputBorder className={styles.inputBorderSvg} />}
      {isFocus && <div className={styles.inputBottomLine} />}
    </div>
  );
};

export default Input;
